import { Expose } from "class-transformer";
import type { UUID } from "crypto";
import type { DisabilityTypeEnum } from "../../enums/disability-type.enum";
import type { IDisabilityDto } from "./disability.dto.interface";

export class DisabilityDto implements IDisabilityDto {
  @Expose()
  id!: UUID;

  @Expose()
  disabilityType!: DisabilityTypeEnum;

  @Expose()
  disabilityPercentage?: number;
}
